<div header="Update User Data" class="align-items-center">
    <div class="col-12 mb-3 p-0">
        @if (type === userProfileEditTypes.searchMarket || type === userProfileEditTypes.jobType){
            <div class="w-full flex flex-column gap-3 pb-3">
                <div class="flex gap-1">
                    Any changes will be visible to {{userName}}
                </div>
            </div>
            <p-multiSelect [(ngModel)]="config.data.selectedItems"
                display="chip" (onChange)="onChange($event)"
                [options]="dropdownData" optionLabel="name" appendTo="body" [resetFilterOnHide]="true"/>
        }
        @else if (type === userProfileEditTypes.pwcEmail || type === userProfileEditTypes.email) {
            <div class="w-full flex flex-column gap-3 pb-3">
                <div class="flex gap-1">
                    {{'Please Enter' | sentenceCase}} {{type}}:
                </div>
            </div>
            <form #emailForm="ngForm">
                <input class="p-inputtext p-component" id="email" type="email" pInputText [(ngModel)]="value" [ngModelOptions]="{standalone: true}"
                width="100%" #emailField="ngModel" [pattern]="emailRegex" />
                <div *ngIf="emailField.invalid && emailField.touched">
                    @if(emailField.errors?.['pattern']){
                        <div class="p-error">Invalid Email.</div>
                    }
                </div>
            </form>
        }
        @else if (type === userProfileEditTypes.guid || type === userProfileEditTypes.contractorNumber || type === userProfileEditTypes.secondaryContractorNumber) {
            <div class="w-full flex flex-column gap-3 pb-3">
                <div class="flex gap-1">
                    {{'Please Enter' | sentenceCase}} {{type}}:
                </div>
            </div>
            <form #guidForm="ngForm">
                <input class="p-inputtext p-component" id="guid" type="text" pInputText [(ngModel)]="value" [ngModelOptions]="{standalone: true}"
                width="100%" #guidField="ngModel" />
                <div *ngIf="guidField.invalid && guidField.touched">
                    @if(guidField.errors){
                        <div class="p-error">Invalid Value.</div>
                    }
                </div>
            </form>
        } 
        @else if (type === userProfileEditTypes.primaryPayRate || type === userProfileEditTypes.secondaryPayRate) {
            <div class="flex gap-3">
                <div class="flex gap-1 center">
                    {{'Please Enter' | sentenceCase}} {{type}}:
                </div>
                <p-inputNumber [(ngModel)]="value" [style]="{'width': '6rem'}"
                styleClass="slider-style" [showButtons]="true" buttonLayout="vertical"
                spinnerMode="vertical" inputId="vertical" [min]="1" [max]="1000"
                (onInput)="onPayRateChange($event)"
                decrementButtonClass="p-button-text" incrementButtonClass="p-button-text"
                mode="currency" currency="USD" locale="en-US"
                incrementButtonIcon="pi pi-chevron-up" decrementButtonIcon="pi pi-chevron-down"/>
            </div>
        }
        @else if (type === userProfileEditTypes.ranking) {
            <div class="w-full flex flex-column gap-3 pb-3">
                <div class="flex gap-1">
                    {{'Please Select' | sentenceCase}} {{type}}:
                </div>
            </div>
            <p-dropdown
                [(ngModel)]="config.data.selectedItems[0]"
                [options]="dropdownData"
                optionLabel="name"
                appendTo="body"
                (onChange)="onChange($event)"
                inputId="float-label"
            />
        }
    </div>
   
    <div class="flex justify-content-end gap-2">
        <p-button label="cancel" [outlined]="true" [rounded]="true" (click)="closeDialog()" />
        <p-button [disabled]="!config.data.selectedItems.length" label="ok" (click)="confirm()" />
    </div>
</div>